// src/runtime/axiosClient.ts
import type { AxiosInstance } from 'axios';
import { createAxiosInstance } from 'host/createAxios';
import { handleUnauthorized } from 'host/axiosHostHandlers';

// Set once during setupRuntime()
export let axios!: AxiosInstance; 

export function initAxios(baseURL: string): AxiosInstance {
    axios = createAxiosInstance({
        baseURL,
        hooks: { onUnauthorized: handleUnauthorized },
    });
    return axios;
}
